<template>
  <div style="background-color:#fff;height: 100%;">
      <mini_head_top> </mini_head_top>
      <van-row  type="flex"  justify="space-between" style=" padding: auto; margin-top: 10px; width: 100%;text-align: left">
        <van-col :span= '20'>
          <span style="margin-left: 0px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:16px; font-weight:700">{{ theme }}</span>
        </van-col>
        <van-col >
          <el-link :span= '4' style="margin-right: 10px;" type="primary" @click.native="goHome()">主页 <i class= "el-icon-s-home"> </i></el-link>
        </van-col>        
      </van-row >
      <van-row type="flex"  justify="begin" style="margin-left:15px">
        <el-checkbox v-if = "fileType != '通知公告' &&  fileType != '办事指南'"  v-model="basicState" disabled >实验室准入教程</el-checkbox>
        <el-checkbox @change ="changeLearn" v-if = "fileType != '通知公告' &&  fileType != '办事指南' && fileType != '安全责任书' && basicState"  v-model="learned"  :disabled = "learnBtnCtr"  >已学习</el-checkbox>
      </van-row >
      <div class = "w-e-text-container" style="overflow:auto; height:calc(80vh - 60px);">
        <div data-slate-editor style="overflow:auto !important; width: 100%;" v-html="content">
        </div>
      </div>
      <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0', margin:'2px' }">
      </van-divider>
      <div style=" display:flex;margin-top: 5px; "  v-if=" funtFootType==1 && fileUrl != null && fileUrl != ''" >
        <div style="margin:auto;display:flex;align-items: center;">
          <el-link type="primary" @click = "attachDownLoad" >附件:{{ fileName }}</el-link>
        </div>
      </div>
  </div>
</template>                     
<script>
// 引入组
import logo from "@/assets/image/yuanhui.png"
import '@wangeditor/editor/dist/css/style.css'
import {getToken} from  '@/api/utils'
import axios from  '@/api/axiosConfig'
import mini_head_top from "@/mini_pages/mini_head_top"
import {MESSAGE_DURATION,fileType} from  '@/api/constant'
export default {
  name : 'pc_ctr_editor_view',
  data() {
    return {
      logo,
      funtFootType :'', // 1  文件 /2 图片 / 3 画布
      isDrawing: false, // 是否正在绘制
      context: null, // Canvas上下文
      id :"",
      theme : "",
      content:"",
      fileName:'',
      fileType : "",
      fileUrl :'',
      learnBtnCtr: false,
      learned : false,
      basicState : false,
      tokenObj:{
        token :''
      }
    }
  },
  methods : {
    goHome(){
      this.$router.push({path:'/mini_index'})
    },
    changeLearn(val){
      if(val){
        if(this.fileType=='规章制度'){
          this.markRegLearned()
          return 
        }
        if(this.fileType=='安全知识'){
          this.markKnLearned()
          return 
        }
      }
    },
    markRegLearned (){
    let url = "/bc/exa/reg/regLearn"
    let dat0 = {
      id: this.id
    }
    this.learnBtnCtr = true
    axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) { 

        }else{
          this.learnBtnCtr = false
          this.learned = false
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.learned = false
        this.learnBtnCtr = false
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
      })
    });

    },

    markKnLearned (){
    let url = "/bc/exa/kn/knLearn"
    let dat0 = {
      id: this.id
    }
    this.learnBtnCtr = true
    axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) { 
          
        }else{
          this.learnBtnCtr = false
          this.learned = false
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.learned = false
        this.learnBtnCtr = false
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
      })
    });

    },
    attachDownLoad(){
      let that = this
      let outData = {}  //传参数据
      let url = this.fileUrl; //接口
      let xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = "blob";  // 返回类型blob
      xhr.setRequestHeader("Content-type", "application/json;charset=utf-8");
      xhr.setRequestHeader("token", this.tokenObj.token); //这个看后端接口情况决定要不要写
      // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
      xhr.onload = function () {
          // 请求完成
          if (this.status === 200) {
              // 返回200
              var blob = this.response;
              const a = document.createElement('a');
              const url = window.URL.createObjectURL(blob);
              let reader = new FileReader();
              reader.readAsDataURL(blob);  // 转换为base64，可以直接放入a表情href
              reader.onload = function (e) {
                  // 转换完成，创建一个a标签用于下载
                let a = document.createElement('a');
                a.download = that.fileName;
                a.href = e.target.result;
                document.body.appendChild(a);
                // 修复firefox中无法触发click
                a.click();
                document.body.removeChild(a);
              }
          } else {
            that.$message({
              showClose: true,
              message: "下载失败：" + xhr.statusText,
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
      };
      xhr.onerror = function () {
        that.$message({
          showClose: true,
          message: "下载失败：" + xhr.statusText,
          type: 'info',
          duration: MESSAGE_DURATION
        })
      }
      // 发送ajax请求
      xhr.send(JSON.stringify(outData))
    },
    // 加载一个通知公告
    noticeOneLoad(id){
      let url = "/bc/exa/notice/getNoticeInfo"
      let dat0 = {
        id: id
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            let attachFileList = response.data.data.attachFileList
            if(attachFileList != null && attachFileList.length!= 0){
              this.funtFootType = 1
              this.fileName = attachFileList[0].fileName
              this.fileUrl = attachFileList[0].url
            }
          } else {
            this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },
    // 加载一个安全知识
    knOneLoad(id){
      let url = "/bc/exa/kn/getKnLearnInfo"
      let dat0 = {
        id: id
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            this.basicState = response.data.data.basicState == 1
            this.learned = response.data.data.learned > 0
            if(this.learned){
              this.learnBtnCtr = true
            }
          } else {
            this.$message({
              showClose: true,
              message: '未查询相关信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },
    // 加载一个规章制度
    regOneLoad(id){
      let url = "/bc/exa/reg/getLearnRegInfo"
      let dat0 = {
        id: id
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            let attachFileList = response.data.data.attachFileList
            this.basicState = response.data.data.basicState == 1
            this.learned = response.data.data.learned > 0
            if(this.learned){
              this.learnBtnCtr = true
            }
            if(attachFileList != null && attachFileList.length!= 0){
              this.funtFootType = 1
              this.fileName = attachFileList[0].fileName
              this.fileUrl = attachFileList[0].url
            }
          } else {
            this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },
    // 加载一个办事指南
    guidOneLoad(id){
      let url = "/bc/exa/guid/getGuidInfo"
      let dat0 = {
        id: id
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            let attachFileList = response.data.data.attachFileList
            if(attachFileList != null && attachFileList.length!= 0){
              this.funtFootType = 1
              this.fileName = attachFileList[0].fileName
              this.fileUrl = attachFileList[0].url
            }
          } else {
            this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    }
  },
  created () {
    setTimeout(()=>{getToken(this.tokenObj)},200)
    this.id = this.$route.query.id
    this.fileType =  this.$route.query.fileType
    switch(this.fileType) {
      case fileType.NOTICE_FILE:
          this.noticeOneLoad(this.id)
          break
      case fileType.SAFE_KNOWLEDGE:
          this.knOneLoad(this.id)
          break   
      case fileType.REGULATIONS.NAME:
          this.regOneLoad(this.id)
          break   
      case fileType.WORK_GUID:
          this.guidOneLoad(this.id)
          break   
    }
  },
  mounted() {
   
  },
  components:{
      mini_head_top
    }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%

}
/deep/.el-card__body {
  padding-top:0px;
}
.text {
  font-size: 14px;
  color: #000;
}

.notice-content-view {
  border: 3px solid #ccc;
  border-radius: 5px;
  padding: 0 10px;
  margin-top: 20px;
  overflow-x: auto;
}

.notice-content-view p,
.notice-content-view li {
  white-space: pre-wrap; /* 保留空格 */
}

.notice-content-view blockquote {
  border-left: 8px solid #d0e5f2;
  padding: 10px 10px;
  margin: 10px 0;
  background-color: #f1f1f1;
}

.notice-content-view code {
  font-family: monospace;
  background-color: #eee;
  padding: 3px;
  border-radius: 3px;
}
.notice-content-view pre>code {
  display: block;
  padding: 10px;
}

.notice-content-view table {
  border-collapse: collapse;
}
.notice-content-view td,
.notice-content-view th {
  border: 1px solid #ccc;
  min-width: 50px;
  height: 20px;
}
.notice-content-view th {
  background-color: #f1f1f1;
}

.notice-content-view ul,
.notice-content-view ol {
  padding-left: 20px;
}

.notice-content-view input[type="checkbox"] {
  margin-right: 5px;
}
.el-divider--horizontal{
  background-color: #2577d5;
  height: 3px;
  margin: 1px 0 1px 0;
  width: 100%
}
</style>
    


// WEBPACK FOOTER //
// src/mini_pages/mini_view_editor.vue